export default function parseTimeSpent(input: string): number {
  let hours = 0;
  let restPart = input;
  if (input.includes('h')) {
    hours = parseInt(input.split('h')[0], 10);
    restPart = input.split('h')[1];
  }
  const mins = parseInt(restPart, 10);

  return (isNaN(mins) ? 0 : mins) + hours * 60;
}
